<template>
  <div>
    <Address :addressInfo="addressInfo"></Address>
    <Product :proInfo="proInfo"></Product>
    <div class="pay-type">
      <van-radio-group v-model="payType">
        <!-- <van-cell-group>
          <van-cell clickable @click="payType = 1">
            <template name="title">
              <div class="pay-title">
                <img class="img-icon" src="../../assets/icon/intePay.png" width="100%" />
                <p key="pay" v-if="inte">¥支付( 当前¥: {{ $setInfoDecimal(inte) }} )</p>

              </div>
            </template>

            <template #right-icon>
              <van-radio :name="1" />
            </template>
          </van-cell>
        </van-cell-group> -->
        <van-cell-group>
          <van-cell clickable @click="payType = 3">
            <template name="title">
              <div class="pay-title">
                <img class="img-icon" src="../../assets/icon/wechat.png" width="100%" />
                <p key="pay">微信支付</p>

              </div>
            </template>

            <template #right-icon>
              <van-radio :name="3" />
            </template>
          </van-cell>
        </van-cell-group>

        <!-- <van-cell-group>
          <van-cell clickable @click="payType = 4">
            <template name="title">
              <div class="pay-title">
                <img class="img-icon" src="../../assets/icon/alipay.png" width="100%" />
                <p key="pay">支付宝支付</p>

              </div>
            </template>

            <template #right-icon>
              <van-radio :name="4" />
            </template>
          </van-cell>
        </van-cell-group> -->
      </van-radio-group>
    </div>
    <!-- <Notice></Notice> -->
    <div class="payment">
      <div class="total">
        <p>应付¥: {{ $setInfoDecimal(total) }} </p>
        <!-- <p v-if="inte">剩余¥: {{ surplus }}</p> -->
      </div>
      <div class="pay-btn"><button @click="paying">去付款</button></div>
    </div>
  </div>
</template>
<script>
import { Address, Product } from './components'

import paymentHandle from '@/utils/paymentHandle'
import { getAddressId, setAddressId } from '@/utils/Address'
import { preview, previewOneKey, orderDdd, repay } from '@/api/order'
import { doPay, getUserInte } from '@/api/pay'
import { getuser } from '@/api/user'
// import { getWechatOauth } from " @/api/user";

import { RadioGroup, Radio, Cell, CellGroup, Dialog } from 'vant'
import { getDefaultAddress, getAddressInfo } from '@/api/address'

import weChatJsApiPay from '@/utils/weChatJsApiPay'

import { adType } from '@/utils/Address'


// 检查是否在微信浏览器
function isWeChatWeb () {
  var ua = navigator.userAgent.toLowerCase()
  var isWeixin = ua.indexOf('micromessenger') != -1

  return isWeixin
}

export default {
  name: 'Payment',
  components: {
    Address,
    Product,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog
  },
  data () {
    return {
      addressInfo: {},
      proInfo: [],
      payType: 3,
      inte: 0,
    }
  },
  methods: {
    // 获取用户¥
    async getUserInfo () {
      const result = await getUserInte()
      this.inte = result.data.data.inte
    },
    // 获取商品列表
    async getPro () {

      // 判断时候有地址
      if (!getAddressId()) return

      const payment = paymentHandle.getPayment()
      let result

      // 获取商品信息

      // 获取购物车类型商品信息
      if (payment.payType === paymentHandle.type.cart) {
        result = await preview({
          address_id: getAddressId(),
          carts_id: paymentHandle.getPayment().payId,
        })
      }

      // 获取立即购买类型商品信息
      if (payment.payType === paymentHandle.type.buyNow) {
        result = await previewOneKey({
          address_id: getAddressId(),
          goods_sn: paymentHandle.getPayment().payId,
        })
      }

      if (result.data.data.status) {
        this.proInfo = result.data.data.orderInfo.orderGoods
      } else {
        setTimeout(() => {
          this.$router.go(-1)
        }, 2000);
      }

    },
    // 支付处理
    paying () {
      // if (this.surplus === '¥不足') {
      //   this.$toast('当前¥不足, 无法支付')
      //   return
      // }

      Dialog.confirm({ title: '是否支付订单' }).then(() => {
        this.payment()
      })
    },

    // 唤起支付
    async payment () {
      const { payType } = this

      // 获取支付信息
      const payment = paymentHandle.getPayment()

      let type
      // 判断支付类型
      if (payment.payType === paymentHandle.type.cart) {
        type = 'carts_id'
      }
      if (payment.payType === paymentHandle.type.buyNow) {
        type = 'goods_sn'
      }

      try {
        const result = await orderDdd({
          [type]: String(paymentHandle.getPayment().payId),
          address_id: getAddressId(),
          payment_type: payType
        })

        this.$toast(result.data.data.message)

        if (result.data.data.status) {
          const payment = result.data.data.orderInfo.payment
          if (payment.length !== 0) {
            payment.map(async (item) => {

              // if (item.payType === 1) {
              //   // ¥支付
              //   this.intePay(item, result.data.data.orderInfo.order_sn)
              // }

              if (item.payType == 3) {
                if (isWeChatWeb()) {
                  this.weChatPayByjsApi(item.pay_id, result.data.data.orderInfo.order_sn)
                } else {
                  this.webWeChatPayByWeb(item.pay_id)
                }
              }

            })
          } else {
            // 重新支付
            // this.rePay(result.data.data.orderInfo.order_sn)
          }
        }
      } catch (err) { }
    },
    // 重新支付
    async rePay (order_sn) {
      const result = await repay({
        order_sn,
        payment_type: 1
      })

      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.replace({
          name: 'payOrderStatus',
          query: {
            id: order_sn
          }
        })
      }
    },
    // 积分支付
    async intePay (info, order_sn) {
      if (info.status) {
        this.$router.replace({
          name: 'payOrderStatus',
          query: {
            id: order_sn
          }
        })
      } else {
        const result = doPay({
          pay_id: info.pay_id
        })

        this.$toast(result.data.message)
        if (result.data.status) {
          this.$router.replace({
            name: 'payOrderStatus',
            query: {
              id: order_sn
            }
          })
        }
      }
    },
    // h5微信支付
    async webWeChatPayByWeb (pay_id) {
      try {
        const result = await doPay({
          pay_id: pay_id,
        })
        if (result.data.data.status) {

          const payment = result.data.data.payment

          if (payment.pay_data.trade_type === 'MWEB') {

            document.location.href = payment.pay_data.mweb_url
          }
        }
      } catch (err) { }

    },
    async getWechatOpenId () {
      const result = await getuser()
      if (result.data.data.status) {
        if (result.data.data.isBindWechat) {
          return result.data.data.openId
        }
      }
    },
    // 微信jsApi支付
    async weChatPayByjsApi (pay_id, order_sn) {

      try {
        // 获取openId
        const openid = await this.getWechatOpenId()

        const result = await doPay({
          pay_id: pay_id,
          openid: openid
        })


        if (result.data.data.status) {
          const payInfo = result.data.data.payment.pay_data
          const payResult = await weChatJsApiPay(payInfo)
          if (payResult) {
            this.$toast('支付成功')
            this.$router.replace({
              name: 'payOrderStatus',
              query: {
                id: order_sn
              }
            })
          } else {
            this.$toast('支付失败')
          }
        }
      } catch (err) {

      }

    },
    // 获取地址
    async getAddress () {

      if (getAddressId()) {
        // 获取地址信息
        const result = await getAddressInfo({
          address_id: getAddressId(),
        })
        this.setadId(result.data.data)
      } else {

        // 获取默认地址
        const result = await getDefaultAddress()
        if (Object.keys(result.data.data.addressInfo).length !== 0) {
          this.setadId(result.data.data)
        } else {

          this.$router.replace({
            path: `myaddress#${adType['payment']}`,
          })
        }
      }
    },
    // 设置地址
    setadId (adInfo) {
      if (adInfo.status) {
        setAddressId(adInfo.addressInfo.address_id)
        this.addressInfo = adInfo.addressInfo
        this.getPro()
      }
    },

  },
  created () {
    this.getAddress()
    this.getUserInfo()
  },
  computed: {
    // 剩余¥计算
    surplus () {
      const { inte, total, $setInfoDecimal } = this
      return inte - total >= 0 ? $setInfoDecimal(inte - total) : '¥不足'
    },
    // 总计
    total () {
      return this.proInfo.reduce((total, item) => {
        return total + item.num * item.goods_price
      }, 0).toFixed(2)
    },
  },
}
</script>
<style lang="scss" scoped>
.payment {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  height: 1.14rem;
  @include flexBox(space-around);
  font-size: 0.32rem;
  .total {
    width: 4.28rem;
    height: 0.71rem;
    background: $globalcolor;
    border-radius: 10px;
    color: white;
    padding: 0.1rem 0.2rem;
    font-size: 0.28rem;
    P {
      margin: 0;
    }
  }
  .pay-btn button {
    width: 2.26rem;
    height: 0.91rem;
    background: #ff6161;
    border-radius: 10px;
    border: none;
    color: white;
  }
}
.payment {
  background: #fff;
  border-radius: 10px;
  margin: auto;
  margin-top: 1.1rem;
  margin-bottom: env(safe-area-inset-bottom);
}
.pay-title {
  display: flex;
  align-items: center;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  p {
    margin-left: 0.2rem;
  }
}

.pay-type {
  margin: 0.7rem 0 1rem 0;
}
</style>